export default __webpack_public_path__ + "static/media/Typewriter.e4cb431a.png";